import { BenchmarkingItemWithUnit, BenchmarkingReportSettings } from '@/hooks'
import { SQUARE_FOOTAGE_UNIT } from '@/utils/constants'

export const getUnitFromBenchmarkingData = (
    data: BenchmarkingItemWithUnit[],
    applySquareFootage: boolean,
    basis: BenchmarkingReportSettings['basis']
): string => {
    if (!data[0]) {
        return ''
    }

    const currency = data[0].cost.currency
    const usageUnit = data[0].usage.unit
    const emissionUnit = data[0].emission?.unit

    if (basis === 'usage') {
        if (applySquareFootage) {
            return `${usageUnit} / ${SQUARE_FOOTAGE_UNIT}`
        }

        return usageUnit
    }

    if (basis === 'cost') {
        if (applySquareFootage) {
            return `${currency} / ${SQUARE_FOOTAGE_UNIT}`
        }

        return currency
    }

    if (basis === 'costPerUsage') {
        return `${currency} / ${usageUnit}`
    }

    if (emissionUnit) {
        if (applySquareFootage) {
            return `${emissionUnit} / ${SQUARE_FOOTAGE_UNIT}`
        }

        return emissionUnit
    }

    return ''
}
